import { ADD_INFO_FEATURE, REMOVE_INFO_FEATURE } from './actionTypes';

export const addInfoFeature = (feature) => (dispatch) => {
  dispatch({
    type: ADD_INFO_FEATURE,
    payload: feature,
  });
};
export const removeInfoFeature = () => (dispatch) => {
  dispatch({
    type: REMOVE_INFO_FEATURE,
  });
};
